import { create } from 'zustand'
import {
  readHealthcareAccessToken,
  readHealthcareAppsCode,
  readHealthcareRefreshToken,
} from '@/auth/healthcareUiStorage'

export type AuthUser = {
  appsCode?: string | null
  permissionList?: string[]
  uriList?: string[]
  empName?: string
}

export type EnterpriseSessionSlice = {
  accessToken: string | null
  refreshToken: string | null
  appsCode: string | null
  user: AuthUser | null
  setSession: (payload: {
    accessToken: string
    refreshToken?: string | null
    appsCode: string
    user: AuthUser
  }) => void
  clearSession: () => void
}

const initial = {
  accessToken: readHealthcareAccessToken(),
  refreshToken: readHealthcareRefreshToken(),
  appsCode: readHealthcareAppsCode(),
  user: null as AuthUser | null,
}

export const useAuthStore = create<EnterpriseSessionSlice>((set) => ({
  ...initial,
  setSession: ({ accessToken, refreshToken, appsCode, user }) =>
    set({ accessToken, refreshToken: refreshToken ?? null, appsCode, user }),
  clearSession: () =>
    set({
      accessToken: null,
      refreshToken: null,
      appsCode: null,
      user: null,
    }),
}))

/** Sync JWTAuthContext user into the catalog session slice (Phase-1 native shell). */
export function syncHealthcareUiSession(user: AuthUser | null): void {
  useAuthStore.setState({
    user,
    appsCode: user?.appsCode ?? readHealthcareAppsCode(),
    accessToken: readHealthcareAccessToken(),
    refreshToken: readHealthcareRefreshToken(),
  })
}
